module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/media/super-touch-video-zh.212d0cf9.mp4";